import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';

const AboutMe = () => {
  return (
    <Container  py={6}  maxW="container.lg" id='about'>
      <Box
        bg={useColorModeValue('#78B7D0', '#86469C')}
        px={12}
        py={12}
        borderRadius="lg"
        boxShadow="lg"
        
        border="2px solid #3182CE"
      >
        <Heading as="h1" fontSize="4xl" color={'#3182CE'} mb={4} box-shadow= 'rgba(0, 0, 0, 0.24) 0px 3px 8px;' >
          About Me!
        </Heading>
        <Text fontSize="2xl" mb={4}>
         {/* <Heading>Deepak</Heading> */}
        </Text>
        <Text fontSize="2xl" mb={4}>
        <Heading>Full Stack Web Developer</Heading>
          
        </Text>
        <Divider my={4} />
        <Text fontSize="lg" mb={4} fontFamily={'Cairo, sans-serif, Rajdhani, sans-ser, Tektur, cursive'}>
        Experienced in HTML, CSS, JavaScript, React.js, Redux.js, TypeScript, Node.js, Express.js, MongoDB, and OpenAI, with a strong focus on delivering exceptional digital experiences. Thrives in collaborative and interdisciplinary teams, consistently executing goal-oriented projects that enhance user experience. Proficient in agile methodologies and project management, contributing to successful and impactful outcomes. A motivated, skilled, and team-oriented developer, well-suited for any software development team striving for excellence.
        </Text>
      </Box>
    </Container>
  );
};

export default AboutMe;
